'use strict';

module.exports = function (obj) {

  return obj == null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-nil/index.js
// module id = 208
// module chunks = 2